import { useState, useCallback } from "react";
import { TouchpointCreateRequestType } from "generated/schemas";
import AddTouchpointModal from "components/modals/creative-modal/components/add-touchpoint-modal";
import { ConfirmationDialog } from "ui/confirmation-dialog";

interface UseAddTouchpointModalProps {
  folderId?: string;
}

export const useAddTouchpointModal = ({ folderId }: UseAddTouchpointModalProps = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmExitOpen, setIsConfirmExitOpen] = useState(false);
  const [touchpointType, setTouchpointType] = useState<TouchpointCreateRequestType>(TouchpointCreateRequestType.LANDING_PAGE);

  const openAddTouchpointModal = useCallback((type: TouchpointCreateRequestType) => {
    setTouchpointType(type);
    setIsOpen(true);
  }, []);

  const closeAddTouchpointModal = useCallback(() => {
    setIsOpen(false);
    setIsConfirmExitOpen(false);
  }, []);

  const openConfirmExit = useCallback(() => {
    setIsConfirmExitOpen(true);
  }, []);

  const closeConfirmExit = useCallback(() => {
    setIsConfirmExitOpen(false);
  }, []);

  const handleConfirmExit = useCallback(() => {
    closeAddTouchpointModal();
  }, [closeAddTouchpointModal]);

  const addTouchpointModalMarkup = (
    <>
      {isOpen && (
        <AddTouchpointModal
          isOpen={true}
          onClose={closeAddTouchpointModal}
          onConfirmClose={openConfirmExit}
          folderId={folderId}
          type={touchpointType}
        />
      )}

      {isConfirmExitOpen && (
        <ConfirmationDialog
          open
          onClose={closeConfirmExit}
          onConfirm={handleConfirmExit}
          intent="warning"
          closable={false}
          headline="Leave without saving?"
          message="All unsaved changes will be lost."
          cancelButtonText="Continue editing"
          confirmButtonText="Leave setup"
        />
      )}
    </>
  );

  return {
    openAddTouchpointModal,
    addTouchpointModalMarkup,
  };
};
